var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteLabel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1072_2850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33337 2.49992C3.11236 2.49992 2.9004 2.58772 2.74412 2.744C2.58784 2.90028 2.50004 3.11224 2.50004 3.33325V4.99992C2.50004 5.46016 2.12694 5.83325 1.66671 5.83325C1.20647 5.83325 0.833374 5.46016 0.833374 4.99992V3.33325C0.833374 2.67021 1.09677 2.03433 1.56561 1.56548C2.03445 1.09664 2.67033 0.833252 3.33337 0.833252H5.00004C5.46028 0.833252 5.83337 1.20635 5.83337 1.66659C5.83337 2.12682 5.46028 2.49992 5.00004 2.49992H3.33337Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1666 1.66659C14.1666 1.20635 14.5397 0.833252 15 0.833252H16.6666C17.3297 0.833252 17.9656 1.09664 18.4344 1.56548C18.9032 2.03433 19.1666 2.67021 19.1666 3.33325V4.99992C19.1666 5.46016 18.7935 5.83325 18.3333 5.83325C17.8731 5.83325 17.5 5.46016 17.5 4.99992V3.33325C17.5 3.11224 17.4122 2.90028 17.2559 2.744C17.0996 2.58772 16.8876 2.49992 16.6666 2.49992H15C14.5397 2.49992 14.1666 2.12682 14.1666 1.66659Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 14.1667C18.7935 14.1667 19.1666 14.5398 19.1666 15.0001V16.6667C19.1666 17.3298 18.9032 17.9657 18.4344 18.4345C17.9656 18.9034 17.3297 19.1667 16.6666 19.1667H15C14.5397 19.1667 14.1666 18.7937 14.1666 18.3334C14.1666 17.8732 14.5397 17.5001 15 17.5001H16.6666C16.8876 17.5001 17.0996 17.4123 17.2559 17.256C17.4122 17.0997 17.5 16.8878 17.5 16.6667V15.0001C17.5 14.5398 17.8731 14.1667 18.3333 14.1667Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66671 14.1667C2.12694 14.1667 2.50004 14.5398 2.50004 15.0001V16.6667C2.50004 16.8878 2.58784 17.0997 2.74412 17.256C2.9004 17.4123 3.11236 17.5001 3.33337 17.5001H5.00004C5.46028 17.5001 5.83337 17.8732 5.83337 18.3334C5.83337 18.7937 5.46028 19.1667 5.00004 19.1667H3.33337C2.67033 19.1667 2.03445 18.9034 1.56561 18.4345C1.09677 17.9657 0.833374 17.3298 0.833374 16.6667V15.0001C0.833374 14.5398 1.20647 14.1667 1.66671 14.1667Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 15C9.53972 15 9.16663 14.6269 9.16663 14.1667V5.83333C9.16663 5.3731 9.53972 5 9.99996 5C10.4602 5 10.8333 5.3731 10.8333 5.83333V14.1667C10.8333 14.6269 10.4602 15 9.99996 15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 15C5.3731 15 5 14.6269 5 14.1667L5 5.83333C5 5.3731 5.3731 5 5.83333 5C6.29357 5 6.66667 5.3731 6.66667 5.83333L6.66667 14.1667C6.66667 14.6269 6.29357 15 5.83333 15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 15C13.7065 15 13.3334 14.6269 13.3334 14.1667V5.83333C13.3334 5.3731 13.7065 5 14.1667 5C14.6269 5 15 5.3731 15 5.83333V14.1667C15 14.6269 14.6269 15 14.1667 15Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1072_2850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLabel);
export default __webpack_public_path__ + "static/media/white_label.1e800d28be8fd0ca1d06e51921ea5143.svg";
export { ForwardRef as ReactComponent };